var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDatePicker01 = function SvgIconDatePicker01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_date_picker-01_svg2__a",
    x1: 3.45,
    x2: 96.55,
    y1: 50,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m95.63 63.54-9.23-9.23a3.126 3.126 0 0 0-4.42 0l-27.7 27.7c-.39.39-.66.87-.81 1.39l-3.43 12.66c-.45 1.67.53 3.38 2.2 3.83.54.14 1.1.14 1.63 0l12.66-3.43c.53-.14 1.01-.42 1.39-.81l27.7-27.7a3.126 3.126 0 0 0 0-4.42ZM64.1 90.65l-6.6 1.79 1.79-6.6 24.9-24.9L89 65.75zm-18.32 3.1H14.24c-2.5 0-4.53-2.03-4.53-4.53V36.84H90.3v12.11c0 1.73 1.4 3.12 3.12 3.12s3.12-1.4 3.12-3.12V17.69c0-5.95-4.83-10.78-10.78-10.78h-8.95V3.13c0-1.73-1.4-3.12-3.12-3.12s-3.12 1.4-3.12 3.12v3.78H29.44V3.13c0-1.73-1.4-3.12-3.12-3.12s-3.12 1.4-3.12 3.12v3.78h-8.95c-5.95 0-10.78 4.83-10.78 10.78v71.53C3.47 95.17 8.3 100 14.25 100H45.8c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12ZM14.24 13.16h8.95v3.78c0 1.73 1.4 3.12 3.13 3.12s3.12-1.4 3.12-3.12v-3.78h41.12v3.78c0 1.73 1.4 3.12 3.12 3.12s3.12-1.4 3.12-3.12v-3.78h8.95c2.5 0 4.53 2.03 4.53 4.53v12.9H9.7v-12.9c0-2.5 2.03-4.53 4.53-4.53Z",
    style: {
      fill: "url(#icon_date_picker-01_svg2__a)"
    }
  }));
};
export default SvgIconDatePicker01;